import React, { useReducer, useState } from "react";
import Grid from "@mui/material/Grid2";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Box,
  Typography,
  Icon,
  FormControl,
  FormHelperText,
} from "@mui/material";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import SiderBorder from "../../../components/SiderBorder";
import PasswordBox from "../../../components/PasswordBox";
import BackLogin from "../../../components/BackLogin";
import { useParams, useNavigate } from "react-router-dom";
import {
  setPassword,
  setPasswordState,
  setPasswordStateMange,
} from "./setPasswordData";
import { useLoading } from "../../../../context/LodingContext";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import Swal from "sweetalert2";
import PageLayout from "../../../../layoutcontainers/PageLayout";
const SetPassword = () => {
  const [setPasswordData, dispatch] = useReducer(
    setPasswordStateMange,
    setPasswordState
  );

  const [viewPassword1, setViewPassword1] = useState(false);
  const [viewPassword2, setViewPassword2] = useState(false);
  const { setCirleLoading } = useLoading();
  const { uid, token } = useParams();
  const navigate = useNavigate();

  const handlePasswordVisibility = () => {
    setViewPassword1(!viewPassword1);
  };
  const handlePasswordVisibility2 = () => {
    setViewPassword2(!viewPassword2);
  };
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      setPasswordData.newPassword1Status === "success" &&
      setPasswordData.newPassword2Status === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleSumbit = async () => {
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, setPassword, {
        input: {
          newPassword1: setPasswordData?.newPassword1,
          newPassword2: setPasswordData?.newPassword2,
          uidb64: uid,
          token: token,
        },
      });
      const status = await res?.setPassword?.success;
      const message = await res?.setPassword?.message;

      if (status) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
          didOpen: () => {
            document.querySelector(".swal2-popup").style.zIndex =
              "99999999999999";
          },
        }).then(() => {
          navigate("/sign-in");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
          didOpen: () => {
            document.querySelector(".swal2-popup").style.zIndex =
              "999999999999999";
          },
        });
      }
    } catch (err) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: err?.message,
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const keydownHandler = (event) => {
    if (
      event.key == "Enter" &&
      setPasswordData.newPassword1Status === "success" &&
      setPasswordData.newPassword2Status === "success"
    ) {
      handleSumbit();
    }
  };

  return (
    <PageLayout disableFooter showNavbar>
      <PasswordBox>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Box
            sx={{ display: "flex", alignItems: "center", margin: "10px 0px" }}
          >
            <SiderBorder />{" "}
            <Typography sx={{ color: "#2a9941", display: "inline-block" }}>
              Set Password
            </Typography>{" "}
            <SiderBorder />
          </Box>
        </Box>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 12 }}>
            <MaterialInput
              fullWidth
              onKeyDown={keydownHandler}
              placeholder="New Password"
              name="newPassword1"
              type={viewPassword1 ? "text" : "password"}
              variant="outlined"
              value={setPasswordData.newPassword1}
              onChange={(e) => {
                dispatch({ value: e?.target?.value, name: "newPassword1" });
                dispatch({
                  value: setPasswordData?.newPassword2,
                  name: "newPassword2",
                });
              }}
              error={
                setPasswordData.newPassword1Status === "error" ? true : false
              }
              success={
                setPasswordData.newPassword1Status === "success" ? true : false
              }
              icon={
                viewPassword1
                  ? {
                      direction: "right",
                      component: (
                        <Icon color="#2a9941" fontSize="small">
                          <VisibilityIcon
                            onClick={handlePasswordVisibility}
                            style={{ cursor: "pointer" }}
                          />
                        </Icon>
                      ),
                    }
                  : {
                      direction: "right",
                      component: (
                        <Icon color="#2a9941" fontSize="small">
                          <VisibilityOffIcon
                            onClick={handlePasswordVisibility}
                            style={{ cursor: "pointer" }}
                          />
                        </Icon>
                      ),
                    }
              }
            />
            {setPasswordData.newPassword1Status === "error" && (
              <FormControl error>
                <FormHelperText>Password min 8 and max 15</FormHelperText>
              </FormControl>
            )}
          </Grid>
          <Grid size={{ xs: 12, sm: 12 }}>
            <MaterialInput
              fullWidth
              onKeyDown={keydownHandler}
              placeholder="Confirm Password"
              name="newPassword2"
              type={viewPassword2 ? "text" : "password"}
              variant="outlined"
              value={setPasswordData.newPassword2}
              onChange={(e) => {
                dispatch({ value: e?.target?.value, name: "newPassword2" });
              }}
              error={
                setPasswordData.newPassword2Status === "error" ? true : false
              }
              success={
                setPasswordData.newPassword2Status === "success" ? true : false
              }
              icon={
                viewPassword2
                  ? {
                      direction: "right",
                      component: (
                        <Icon color="#2a9941" fontSize="small">
                          <VisibilityIcon
                            onClick={handlePasswordVisibility2}
                            style={{ cursor: "pointer" }}
                          />
                        </Icon>
                      ),
                    }
                  : {
                      direction: "right",
                      component: (
                        <Icon color="#2a9941" fontSize="small">
                          <VisibilityOffIcon
                            onClick={handlePasswordVisibility2}
                            style={{ cursor: "pointer" }}
                          />
                        </Icon>
                      ),
                    }
              }
            />
            {setPasswordData.newPassword2Status === "error" && (
              <FormControl error>
                <FormHelperText>
                  Confirm password does Not match new password
                </FormHelperText>
              </FormControl>
            )}
          </Grid>
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "end" }}>
          <BackLogin />
        </Box>
        <Box sx={{ padding: "7px 0px", width: "100%" }}>
          <MaterialButton
            onClick={handleSumbit}
            variant="contained"
            color="primary"
            disabled={!checkAllFields()}
            fullWidth
          >
            Submit
          </MaterialButton>
        </Box>
      </PasswordBox>
    </PageLayout>
  );
};

export default SetPassword;
